import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import SvcAsesmen from "@/services/AsesmenAwalGadar/AsesmenAwalGadar";

@Module({ dynamic: true, namespaced: true, store, name: "asesmen-awal-gadar" })
class AsesmenAwalGadar extends VuexModule {
  asesmen = null;
  loading = false;

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  SET_ASESMEN(val: any) {
    console.log("set asesmen", val);
    this.asesmen = val;
  }

  @Action({ rawError: true })
  async getByRegister(register): Promise<void> {
    this.SET_LOADING(true);

    const response = await SvcAsesmen.getByRegister(register);

    this.SET_ASESMEN(response.data.data);
  }

  @Action({ rawError: true })
  async clearData(): Promise<void> {
    this.SET_ASESMEN(null);
  }
}

export default getModule(AsesmenAwalGadar);
